export const timelineData = [
  {
    year: 1953,
    label: 'Основание Радио "Освобождение"',
    description: (
      <p>
        1 марта 1953 года из радиостудии в Мюнхене{' '}
        <a
          href="https://www.svoboda.org/a/istoriya-radio-svoboda/32279546.html"
          target="_blank"
          rel="noreferrer"
        >
          вышла в прямой эфир первая передача
        </a>{' '}
        Радио &quot;Освобождение&quot; на русском языке. К 1954 году
        радиостанция вещала и на других языках, в том числе на украинском,
        белорусском, грузинском, казахском, кыргызском, таджикском, татарском. В
        первые годы Конгресс США спонсировал радио через ЦРУ. В 1959 году
        &quot;Освобождение&quot; было переименовано в Радио Свобода. В 1970-х,
        после того, как западные СМИ начали публиковать материалы о ЦРУ как
        спонсоре холодной войны, Конгресс США стал финансировать Радио Свобода
        напрямую, отказавшись от посредников.
      </p>
    ),
  },
  {
    year: 1976,
    label: 'Слияние Радио Свободная Европа и Радио Свобода',
    description: (
      <p>
        1 октября 1976 года закончилось{' '}
        <a
          href="https://www.svoboda.org/a/rferl-radio-free-europe-75-years-history-photos/33463896/p1.html"
          target="_blank"
          rel="noreferrer"
        >
          слияние
        </a>{' '}
        двух радиостанций – Свободная Европа, которая вещала на страны Восточной
        Европы, и Радио Свобода, вещавшей на СССР. Новая объединенная корпорация
        РСЕ/РС получила статус некоммерческой образовательной организации.
        Количество сотрудников нового СМИ было сокращено приблизительно на 50
        процентов.
      </p>
    ),
  },
  {
    year: 1985,
    label: '"Перестройка" в СССР',
    description: (
      <p>
        Весной 1985 года генеральным секретарем ЦК КПСС был избран Михаил
        Горбачев. С его приходом к власти в Советском Союзе начались реформы,
        которые должны были вывести страну из политического и экономического
        кризиса. Основной целью перестройки власти называли &quot;обновление
        социализма&quot;: переход к рыночной экономике, создание новых выборных
        органов, гласность, а также изменения во внешней политике, направленные
        на завершение холодной войны. Первоначальных целей перестройка не
        достигла – из-за отсутствия четкого плана реформ в советской экономике
        наступил кризис, а политические реформы привели не к развитию
        социализма, а к распаду СССР в 1991 году.
      </p>
    ),
  },
  {
    year: 1988,
    label: 'Радио Свобода перестают глушить в СССР',
    description: (
      <p>
        30 ноября 1988 года власти в Советском Союзе{' '}
        <a
          href="https://www.svoboda.org/a/29624523.html"
          target="_blank"
          rel="noreferrer"
        >
          перестали глушить
        </a>{' '}
        эфиры Радио Свобода, все генераторы постановки помех были отключены. Об
        этом объявил генеральный секретарь ЦК КПСС Михаил Горбачев 8 декабря на
        сессии Генеральной Ассамблеи ООН. Соответствующий приказ был подписан 19
        декабря того же года. &quot;Свобода&quot; была одним из последних
        зарубежных &quot;радиоголосов&quot;, которые перестали глушить в СССР.
      </p>
    ),
  },
  {
    year: 1989,
    label: '"Бархатная революция" в Чехословакии',
    description: (
      <>
        <p>
          17 ноября 1989 года в Праге власти с применением силы разгоняют
          студенческую антиправительственную демонстрацию. После{' '}
          <a
            href="https://www.currenttime.tv/a/czechoslovakia-prague-velvet-revolution-communism/30271895.html"
            target="_blank"
            rel="noreferrer"
          >
            разгона
          </a>{' '}
          митинга протесты{' '}
          <a
            href="https://www.currenttime.tv/a/velvet-revolution-czechoslovakia/30272242.html"
            target="_blank"
            rel="noreferrer"
          >
            усиливаются
          </a>
          .
        </p>

        <p>
          Спустя несколько дней по всей Чехословакии на улицы выходят сотни
          тысяч человек, проходят забастовки. Диссидент и драматург Вацлав Гавел
          собирает движение &quot;Гражданский форум&quot;, оно объединяет
          несогласных с политикой коммунистических властей. К концу месяца под
          давлением протестующих правительство сначала отменяет статью
          Конституции о ведущей роли компартии, в отставку уходит президент ЧССР
          Густав Гусак. Власти соглашаются на проведение свободных выборов. В
          декабре 1989 года в стране обновилось правительство, в него вошли
          представители оппозиции и общественных движений. Федеральное собрание
          Чехословакии избирает президентом Вацлава Гавела.
        </p>
      </>
    ),
  },
  {
    year: 1991,
    label: 'Борис Ельцин – президент РСФСР',
    description: (
      <p>
        12 июня 1991 года председатель Верховного совета РСФСР Борис Ельцин
        побеждает на первых в России президентских выборах. Он набрал более 57%
        голосов в первом туре.
      </p>
    ),
  },
  {
    year: 1991,
    label: 'Начало распада Югославии',
    description: (
      <p>
        Первыми, 25 июня 1991 года, независимость от СФРЮ провозгласили Словения
        и Хорватия. Выход Словении из состава республики привел к так называемой
        Десятидневной войне (27 июня – 7 июля 1991 года) между силами
        территориальной обороны Словении и Югославской народной армией. В том же
        году началась война в Хорватии. Следующие 15 лет военные действия
        происходили почти во всех республиках бывшей Югославии. Жертвами
        вооруженных конфликтов стали сотни тысяч человек.
      </p>
    ),
  },
  {
    year: 1991,
    label: 'Августовский путч',
    description: (
      <p>
        В августе 1991 года консервативно настроенные члены советского
        руководства объявили о создании Государственного комитета по
        чрезвычайному положению – ГКЧП. 19 августа ГКЧП ввел войска в Москву и
        объявил об установлении жесткой цензуры в СМИ. Против путчистов
        выступили высшие органы власти и президент РСФСР Борис Ельцин, который
        призвал россиян сопротивляться госперевороту. В Москве тысячи
        протестующих начали строить баррикады у Дома правительства (Белого
        дома). Захват Белого дома при участии армии и ОМОНа, который планировали
        путчисты, не состоялся. Попытка переворота в СССР заняла три дня, после
        чего участников ГКЧП арестовали.
      </p>
    ),
  },
  {
    year: 1991,
    label: 'Указ о "бюро радиостанции "Свобода"',
    description: (
      <p>
        Президент РСФСР Борис Ельцин 27 августа 1991 года{' '}
        <a
          href="https://www.svoboda.org/a/tridcat-let-nazad-eljtsin-podpisal-ukaz-ob-otkrytii-byuro-radio-svoboda-v-moskve/31431526.html"
          target="_blank"
          rel="noreferrer"
        >
          подписал указ
        </a>
        , который разрешил &quot;Свободе&quot; открыть бюро в Москве. Текст
        документа написал журналист РС Михаил Соколов. Согласно одному из
        пунктов указа, мэр Москвы должен был выделить помещение для работы
        журналистов РС. Мэрия проигнорировала постановление президента. Бюро в
        Москве начало свою работу в ноябре 1991 года.
      </p>
    ),
  },
  {
    year: 1991,
    label: 'СССР прекратил свое существование',
    description: (
      <p>
        Первыми о своей независимости{' '}
        <a
          href="https://www.currenttime.tv/a/ussr-national-movements/31698777.html"
          target="_blank"
          rel="noreferrer"
        >
          объявляют
        </a>{' '}
        Литва и Латвия. Летом 1990-го года декларации о суверенитете приняли
        Россия и Украина. В течение 1991 года все республики выходят из состава
        Союза. 8 декабря 1991 года в усадьбе &quot;Вискули&quot; в Беловежской
        пуще президент РСФСР Борис Ельцин, президент Украины Леонид Кравчук и
        председатель Верховного совета Беларуси Станислав Шушкевич подписали
        договор о роспуске Советского Союза. СССР прекратил свое существование
        как субъект международного права. 12 декабря 1991 года Верховный Совет
        РСФСР ратифицировал Беловежские соглашения. Последним из СССР вышел
        Казахстан – страна приняла декларацию о независимости 16 декабря
        1991-го.
      </p>
    ),
  },
  {
    year: 1993,
    label: 'Распад Чехословакии',
    description: (
      <p>
        В начале 1990-х годов между властями Чехии и Словакии – на тот момент
        еще двух частей одного государства – усилились политические и
        экономические разногласия. В Чехии на выборах победила Гражданская
        демократическая партия, выступавшая за сохранение ЧССР, в Словакии –
        &quot;Движение за демократическую Словакию&quot;, высказывавшееся за
        расширение автономии или независимость. В июне того же года Словакия
        приняла декларацию о суверенитете, а в ноябре Федеральное собрание
        Чехословакии утвердило раздел страны на два независимых государства. В
        ночь на 1 января 1993 года Чехословакия перестала существовать.
      </p>
    ),
  },
  {
    year: 1993,
    label: 'Клинтон решает сократить РСЕ/РС',
    description: (
      <p>
        Вскоре после победы Билла Клинтона на президентских выборах новая
        администрация президента США представила свой экономический план. Он
        включал в себя сокращение бюджетного дефицита на 500 миллиардов
        долларов. В том числе, в связи с изменением международных приоритетов, в{' '}
        <a
          href="https://www.upi.com/Archives/1993/02/22/Clinton-plan-would-shut-down-Radio-Free-Europe-Radio-Liberty/1239730357200/#google_vignette"
          target="_blank"
          rel="noreferrer"
        >
          документе предполагалось
        </a>{' '}
        закрыть Радио Свободная Европа/Радио Свобода.
      </p>
    ),
  },
  {
    year: 1993,
    label: 'Конституционный кризис в России ',
    description: (
      <p>
        В октябре 1993 года в России произошел конституционный кризис, он стал
        кульминацией конфликта между президентом Борисом Ельциным и Верховным
        Советом. В конце сентября 1993-го президент издал указ о роспуске
        парламента. Конституционный суд признал документ незаконным. В ответ на
        указ Ельцина Верховный Совет объявил импичмент президенту и назначил
        исполняющим обязанности главы государства вице-президента Александра
        Руцкого. Конфликт между президентом и Верховным Советом спровоцировал
        вооруженные столкновения на улицах Москвы. В ночь с 3 на 4 октября
        лояльные президенту войска штурмовали Белый дом и арестовали
        представителей ВС. В ходе столкновений в Москве, по некоторым данным,
        погибло более ста человек, сотни получили ранения. В декабре того же
        года в РФ была принята новая Конституция, значительно расширившая
        полномочия президента.
      </p>
    ),
  },
  {
    year: 1994,
    label: 'Переезд РСЕ/РС из Мюнхена в Прагу',
    description: (
      <p>
        Сотрудники РСЕ/РС выступили с идеей переместить штаб-квартиру
        медиакорпорации из Мюнхена в Прагу, что значительно снизило бы расходы
        на ее содержание. Президент Чехии Вацлав Гавел предложил РСЕ/РС занять
        бывшее здание Федерального собрания в Праге.
      </p>
    ),
  },
  {
    year: 1994,
    label: 'Начало Первой чеченской войны',
    description: (
      <p>
        11 декабря 1994 года Борис Ельцин подписал указ &quot;О мерах по
        обеспечению законности, правопорядка и общественной деятельности на
        территории Чеченской Республики&quot;. Вооруженные силы РФ вошли на
        территорию Чечни. Российские власти называли войну &quot;восстановлением
        конституционного порядка&quot;. Осенью 1991 года в Чечне были проведены
        парламентские и президентские выборы. Президентом нового государства
        Чеченская Республика Ичкерия был избран Джохар Дудаев. Президент России
        объявил в Чечне режим чрезвычайного положения, в республику отправлялись
        российские военные. За весь период Первой чеченской войны, по{' '}
        <a
          href="https://www.interfax.ru/russia/755983"
          target="_blank"
          rel="noreferrer"
        >
          официальным данным
        </a>
        , погибли или считаются пропавшими без вести чуть более пяти тысяч
        российских солдат. По{' '}
        <a
          href="https://old.memo.ru/hr/hotpoints/caucas1/msg/2004/12/m28922.htm"
          target="_blank"
          rel="noreferrer"
        >
          данным
        </a>{' '}
        правозащитной организации &quot;Мемориал&quot;, погибли до 50 тысяч
        мирных жителей республики.
      </p>
    ),
  },
  {
    year: 1995,
    label: 'Начало радиовещания из Праги',
    description: (
      <p>
        В мае 1995 года Радио Свободная Европа / Радио Свобода начинает
        экспериментальное вещание из бывшего здания Федерального собрания
        Чехословакии в Праге.
      </p>
    ),
  },
  {
    year: 1995,
    label: '"Свобода" зарегистрирована в России',
    description: (
      <p>
        В 1995 году, спустя 4 года после указа Бориса Ельцина, Радио Свобода
        было зарегистрировано в Госкомпечати РФ как средство массовой
        информации.
      </p>
    ),
  },
  {
    year: 1995,
    label: 'Теракт в Буденновске',
    description: (
      <p>
        14 июня 1995 года отряд чеченских сепаратистов под руководством полевого
        командира Шамиля Басаева{' '}
        <a
          href="https://www.currenttime.tv/a/budyonnovsk-25-years/30665964.html"
          target="_blank"
          rel="noreferrer"
        >
          взял в заложники
        </a>{' '}
        более полутора тысяч человек в центральной больнице города Буденновска в
        Ставропольском крае. Боевики потребовали от российских властей
        прекратить боевые действия в Чечне и начать переговоры с главой
        сепаратистской Республики Ичкерия Джохаром Дудаевым. 17 июня российские
        военные предприняли неудачную попытку штурма больницы, после чего Кремль
        согласился на переговоры с Басаевым. В ночь на 19 июня военные действия
        в Чечне были прекращены. В ходе переговоров был подписан мораторий на
        боевые действия, заложников освободили, а отряду Басаева позволили
        вернуться в Чечню. В результате вооруженного захвата заложников в
        Буденновске погибли 129 человек, еще 415 были ранены.
      </p>
    ),
  },
  {
    year: 1995,
    label: 'Дейтонские соглашения',
    description: (
      <p>
        21 ноября 1995 года на военной базе в Дейтоне (США) после трехнедельных
        переговоров лидеры Боснии и Герцеговины, Хорватии и Союзной Республики
        Югославия при посредничестве США и Европы подписали мирные соглашения.
        Договор должен был завершить трехлетнюю войну в Боснии, жертвами которой
        стали более 100 тысяч человек. Документ утвердил сохранение единого
        государства Босния и Герцеговина, состоящего из двух автономных частей:
        Федерации Боснии и Герцеговины и Республики Сербской. Для обеспечения
        мира в страну было введено около 60 тысяч международных военнослужащих
        НАТО, которые оставались там до 2004 года.
      </p>
    ),
  },
  {
    year: 1996,
    label: 'Президентские выборы в России',
    description: (
      <p>
        В 1996 году в России прошли президентские выборы. Основными кандидатами
        были действующий президент Борис Ельцин и лидер КПРФ Геннадий Зюганов.
        На момент начала предвыборной кампании рейтинг доверия Ельцину составлял
        около 4% на фоне войны в Чечне, тяжелых последствий радикальных
        экономических реформ и коррупционных скандалов. В кампании 1996 года
        использовались современные политтехнологии: большая часть эфирного
        времени крупных телеканалов была отдана Борису Ельцину. Также применялся
        черный пиар, главным образом, против Зюганова. Для повышения рейтинга
        действующего президента была снижена активность боевых действий в Чечне,
        задержки по зарплатам бюджетникам ликвидированы. Выборы проходили в два
        тура: в первом Ельцин набрал около 35%, а Зюганов – около 32%. Между
        первым и вторым туром у президента произошел очередной инфаркт, до дня
        голосования Ельцин оставался в больнице. Во втором туре Борис Ельцин
        победил, набрав около 54% голосов.
      </p>
    ),
  },
  {
    year: 1996,
    label: 'Хасавюртовские соглашения',
    description: (
      <p>
        31 августа 1996 года в городе Хасавюрт представители Российской
        Федерации и самопровозглашенной Чеченской Республики Ичкерия подписали
        мирный договор. Соглашения предусматривали прекращение военных действий
        и полный вывод российских войск из Чечни. Вопрос о статусе республики
        отложили до 31 декабря 2001 года.
      </p>
    ),
  },
  {
    year: 1997,
    label: 'Открытие сайта Радио Свобода',
    description: (
      <p>
        На первом сайте русской службы Радио Свобода была лента новостей и
        несколько тематических рубрик – &quot;Права человека&quot;,
        &quot;Россия&quot;, &quot;Время и мир&quot;, &quot;Культура&quot;.
        Страница русской службы стала первым интернет-ресурсом в корпорации
        РСЕ/РС.
      </p>
    ),
  },
  {
    year: 1999,
    label: 'Операция "Союзная Сила" в Югославии',
    description: (
      <p>
        24 марта 1999 года авиация НАТО начала бомбардировки Югославии после
        того, как власти страны отказались подписать соглашение, которое
        предполагало автономию для Республики Косово и размещение иностранных
        миротворцев на ее территории. Воздушная операция НАТО продолжалась 78
        дней, в ней принимали участие военные из 14 стран. Удары преимущественно
        наносились по военным объектам, инфраструктуре, мостам и объектам связи
        по всей территории Югославии. В ходе бомбардировок погибло несколько сот
        мирных жителей. В итоге югославские войска вышли из Косова, а над
        областью установили международный контроль.
      </p>
    ),
  },
  {
    year: 1999,
    label: 'Начало Второй чеченской войны',
    description: (
      <p>
        7 августа 1999 года группа чеченских боевиков, которой руководили
        полевые командиры Шамиль Басаев и Хаттаб, вторглась на территорию
        Дагестана. Так они поддержали местных исламистов, которые объявили
        шариатское правление в нескольких селах республики. В течение месяца
        российские федеральные войска и дагестанские ополченцы вытеснили
        боевиков на территорию Чечни. На фоне этих событий в российских городах
        произошла серия терактов. В результате взрывов жилых домов в сентябре
        1999 года погибли более 300 человек. Обстоятельства этих происшествий
        остаются спорными. 23 сентября Борис Ельцин подписал указ, который
        предусматривал создание Объединенной группировки войск на Северном
        Кавказе для координации и проведения &quot;контртеррористической
        операции&quot;. Начались массированные бомбардировки Грозного и
        окрестностей, 30 сентября на территорию Чечни вошли сухопутные войска
        РФ. Активные боевые действия в республике шли в 1999 и 2000 годах, но
        официально режим &quot;контртеррористической операции&quot; был отменен
        российскими властями только в 2009 году.
      </p>
    ),
  },
  {
    year: 1999,
    label: 'Приход Путина к власти',
    description: (
      <p>
        Президент России Борис Ельцин 9 августа 1999 года назначил директора ФСБ
        Владимира Путина и.о. премьер-министра страны. Вскоре Ельцин объявляет
        нового премьера своим преемником на посту президента. Менее чем через
        полгода глава государства досрочно подал в отставку. 31 декабря 1999
        года Путин стал исполняющим обязанности президента РФ. Владимир Путин
        пришел к власти на фоне экономического кризиса, продолжающегося военного
        конфликта на Северном Кавказе и серии террористических актов в
        российских городах.
      </p>
    ),
  },
  {
    year: 2000,
    label: 'Задержание Андрея Бабицкого в Чечне',
    description: (
      <p>
        В январе 2000 года во время командировки в Чечню корреспондента русской
        службы Радио Свобода Андрея Бабицкого задержали федеральные войска.
        Журналист работал в Грозном с начала штурма города до середины января и
        ежедневно передавал в редакцию репортажи о ходе боев и судьбе мирных
        жителей. Формальным поводом для задержания послужило отсутствие у
        Бабицкого аккредитации, позднее ему предъявили обвинение в участии в
        вооруженных формированиях. В феврале журналиста передали чеченскому
        вооруженному подполью в обмен на троих российских военнослужащих,
        находившихся в плену у сепаратистов. Власти заявляли, что Бабицкий
        подписал согласие на обмен. Освободить корреспондента РС требовали
        журналисты, политические деятели, а также международные правозащитные
        организации. В конце февраля Андрея Бабицкого освободили и передали
        российским силовикам, после чего журналиста доставили в Москву.
        Уголовное дело против него было прекращено осенью 2000 года. По мнению
        редакции Радио Свобода, дело против Бабицкого было заведено из-за его
        журналистской работы в Чечне.
      </p>
    ),
  },
  {
    year: 2000,
    label: 'Затонула подлодка "Курск"',
    description: (
      <p>
        12 августа атомная подводная лодка &quot;Курск&quot;{' '}
        <a
          href="https://www.currenttime.tv/a/kursk-20-anniversary/30779531.html"
          target="_blank"
          rel="noreferrer"
        >
          затонула
        </a>{' '}
        во время учений в Баренцевом море. На борту находилось 118 человек. По
        официальной версии, во время подготовки к учебной атаке взорвалась
        торпеда, что повлекло за собой детонацию других боеприпасов. В районе
        учебных маневров было зафиксировано два взрыва, после чего экипаж
        &quot;Курска&quot; перестал выходить на связь. После взрывов в живых
        остались 23 человека. Спасательные работы велись больше недели, но
        открыть люк отсека, в котором находились члены экипажа, не удалось.
        Помощь предлагали несколько европейских государств, но власти РФ
        согласились не сразу. Когда норвежские глубоководные водолазы вскрыли
        люк, отсек был заполнен водой, все члены экипажа &quot;Курска&quot; были
        мертвы. Президент РФ Владимир Путин в момент гибели &quot;Курска&quot;
        находился в отпуске и прервал его спустя несколько дней после аварии.
        Генпрокуратура завела дело по факту гибели &quot;Курска&quot; и закрыла
        его в 2002 году в связи с &quot;отсутствием состава преступления&quot;,
        а документы по делу были засекречены.
      </p>
    ),
  },
  {
    year: 2001,
    label: 'Теракты 11 сентября 2001 года в США',
    description: (
      <p>
        Утром 11 сентября 2001 года 19 боевиков радикальной исламистской
        группировки &quot;Аль-Каида&quot; захватили четыре пассажирских
        самолета. Два из них направили в здания Всемирного торгового центра в
        Нью-Йорке, обе башни рухнули. Третий самолет был направлен в здание
        Пентагона. Еще один лайнер разбился неподалеку от города Шенксвилл в
        Пенсильвании. По официальной версии, целью захватчиков, вероятно, были
        Капитолий или Белый дом. В результате терактов погибли почти три тысячи
        человек. Вскоре после теракта президент США Джордж Буш-младший объявил о
        начале &quot;глобальной войны с терроризмом&quot;. Это заявление стало
        отправной точкой для масштабных военных операций США и их союзников по
        всему миру.
      </p>
    ),
  },
  {
    year: 2001,
    label: 'Открытие бюро русской службы РС в Санкт-Петербурге',
    description: (
      <p>
        В апреле 2001 года в Санкт-Петербурге начало работу бюро русской службы.
        Журналисты готовили специальные проекты и вели ежедневные прямые эфиры.
      </p>
    ),
  },
  {
    year: 2002,
    label: 'Путин отменил указ о бюро Радио Свобода в России',
    description: (
      <p>
        В октябре 2022 года Владимир Путин{' '}
        <a
          href="https://www.kommersant.ru/doc/344529"
          target="_blank"
          rel="noreferrer"
        >
          подписал указ
        </a>
        , аннулирующий постановление Ельцина 1991 года. По словам кремлевских
        чиновников, это было сделано для того, чтобы &quot;уравнять&quot; Радио
        Свобода в правах с другими СМИ в России.
      </p>
    ),
  },
  {
    year: 2002,
    label: 'Теракт в Театральном центре на Дубровке',
    description: (
      <>
        <p>
          23 октября группа вооруженных боевиков{' '}
          <a
            href="https://www.currenttime.tv/a/nord-ost-hostages/30911955.html"
            target="_blank"
            rel="noreferrer"
          >
            захватила
          </a>{' '}
          и удерживала в течение трех дней около 900 зрителей и участников
          мюзикла &quot;Норд-Ост&quot; в московском Театральном центре на
          Дубровке. Группой боевиков руководил чеченский полевой командир Мовсар
          Бараев. Боевики угрожали взорвать бомбы, которые разместили по всему
          зданию, и требовали прекращения военных действий в Чечне. В
          переговорах с боевиками участвовали российские политики, врачи,
          журналисты и деятели культуры, которым удалось освободить несколько
          десятков заложников.
        </p>
        <p>
          Утром 26 октября российские силовики начали штурм здания, применив
          неизвестный газ со снотворным и паралитическим эффектом. Из-за
          отсутствия антидота врачам не удалось оказать помощь многим
          заложникам. 130 человек, освобожденных в ходе штурма, погибли,
          отравившись газом. Власти не проводили полноценного судебного
          расследования по факту гибели заложников. Владимир Путин заявлял, что
          &quot;люди погибли не в результате действия газа&quot;, а от
          &quot;обезвоживания, хронических заболеваний, самого факта, что им
          пришлось оставаться в том здании&quot;.
        </p>
      </>
    ),
  },
  {
    year: 2002,
    label: 'Открытие бюро РС в Екатеринбурге',
    description: (
      <p>
        В сентябре 2002 года в Екатеринбурге начало работу бюро русской службы
        Радио Свобода. Журналисты готовили специальные проекты и вели ежедневные
        прямые эфиры.
      </p>
    ),
  },
  {
    year: 2003,
    label: 'Дело "ЮКОСа"',
    description: (
      <p>
        Летом 2003 года по обвинениям в мошенничестве и уклонении от налогов был
        арестован совладелец нефтяной компании &quot;ЮКОС&quot; и экс-глава
        банка &quot;Менатеп&quot; Платон Лебедев, а осенью был арестован глава
        &quot;ЮКОСа&quot; Михаил Ходорковский. Власти утверждали, что компания
        скрывала доходы, используя подставные фирмы. Ходорковский и его
        сторонники называли дело политически мотивированным, поскольку до своего
        ареста глава &quot;ЮКОСа&quot; оказывал финансовую и политическую
        поддержку оппозиционным политическим партиям (например, Союзу правых сил
        и &quot;Яблоку&quot;). Дело &quot;ЮКОСа&quot; стало одним из первых
        примеров усиления контроля Кремля над крупным бизнесом в России.
        Впоследствии Ходорковского и Лебедева приговорили к 14 годам лишения
        свободы.
      </p>
    ),
  },
  {
    year: 2004,
    label: 'Теракт в Беслане',
    description: (
      <p>
        1 сентября 2004 года во время посвященной началу учебного года
        торжественной линейки чеченские боевики{' '}
        <a
          href="https://www.currenttime.tv/a/beslan-15-years-survivors/30140916.html"
          target="_blank"
          rel="noreferrer"
        >
          захватили
        </a>{' '}
        школу №1 в Беслане. Они взяли в заложники более 1100 человек: в
        основном, детей, их родителей и сотрудников школы. Лишенных еды и воды
        заложников удерживали в заминированном школьном спортзале. Два дня с
        боевиками велись переговоры: они требовали вывода российских войск из
        Чечни и личных гарантий безопасности, угрожая убийством заложников. Днем
        3 сентября в школе прогремело два взрыва, после чего начался штурм
        здания, во время которого погибли 334 человека, больше половины из них
        дети. Ранения получили более 700 человек. Почти все боевики были
        ликвидированы. Оставшегося в живых боевика приговорили к пожизненному
        заключению. Имена ответственных за гибель людей во время штурма школы
        так и не были названы.
      </p>
    ),
  },
  {
    year: 2004,
    label: 'Расширение НАТО',
    description: (
      <p>
        В 2004 году произошло крупнейшее расширение НАТО. В военно-политический
        альянс вступили семь стран: Болгария, Румыния, Словакия, Словения,
        Латвия, Литва и Эстония. Вступление стран бывшего социалистического
        лагеря и трех бывших советских республик в НАТО отражало их стремление к
        интеграции с военными западными структурами. Москва восприняла эти
        действия как прямую угрозу своей безопасности, несмотря на заверения
        Запада в оборонительном характере альянса.
      </p>
    ),
  },
  {
    year: 2006,
    label: 'Убийство Анны Политковской',
    description: (
      <p>
        7 октября 2006 года в подъезде своего дома в Москве была застрелена
        журналистка &quot;Новой газеты&quot; Анна Политковская. Расследование
        убийства взял под личный контроль генеральный прокурор России Юрий
        Чайка. По мнению следствия, убийство Политковской могло быть связано
        &quot;с выполнением ею общественного долга&quot;. Анна Политковская
        неоднократно выезжала в районы боевых действий, многие репортажи
        журналистки были посвящены нарушениям прав человека на Северном Кавказе.
        Политковская критиковала действующую власть и лично Владимира Путина. По
        делу об убийстве журналистки было арестовано несколько человек. В 2014
        году суд приговорил исполнителей к срокам от 11 лет лишения свободы до
        пожизненного заключения. Заказчики убийства так и не были названы.
      </p>
    ),
  },
  {
    year: 2006,
    label: 'Закрытие бюро РС в Екатеринбурге',
    description: (
      <p>
        В октябре 2006 года бюро русской службы Радио Свобода в Екатеринбурге
        было закрыто по бюджетным соображениям.
      </p>
    ),
  },
  {
    year: 2007,
    label: 'Закрытие бюро РС в Санкт-Петербурге',
    description: (
      <p>
        В декабре 2007 года бюро русской службы Радио Свобода в Санкт-Петербурге
        закрылось по экономическим причинам.
      </p>
    ),
  },
  {
    year: 2007,
    label: '"Мюнхенская речь" Путина',
    description: (
      <p>
        10 февраля на Мюнхенской конференции по безопасности президент России
        Владимир Путин{' '}
        <a
          href="https://www.currenttime.tv/a/putin-doctrine-analizing-munich-speech/31709917.html"
          target="_blank"
          rel="noreferrer"
        >
          выступил с речью
        </a>
        , которая многими была воспринята как поворотный момент во внешней
        политике России и начало новой фазы отношений с западными странами.
        Путин критиковал &quot;однополярную модель мира&quot;, особо отмечая
        роль США как единственного центра силы, обвинял Соединенные Штаты в
        нарушении международного права и игнорировании интересов других стран.
        Президент России критиковал расширение НАТО, заявляя, что это
        &quot;серьезный провоцирующий фактор, снижающий уровень взаимного
        доверия&quot;. Мюнхенская речь Путина положила начало политической
        конфронтации Москвы и Запада.
      </p>
    ),
  },
  {
    year: 2008,
    label: 'Медведев вместо Путина',
    description: (
      <p>
        В мае 2008 года в России состоялись выборы президента. Согласно
        Конституции, действующий глава государства Владимир Путин не мог
        баллотироваться на третий срок. Кандидатом был выдвинут первый
        вице-премьер Дмитрий Медведев, близкий соратник Путина. Победив на
        выборах, Медведев занял пост президента, а Путин возглавил
        правительство. Такая конфигурация власти получила в СМИ название
        &quot;тандем&quot; – формальная смена должностей при сохранении ключевых
        рычагов управления в прежних руках.
      </p>
    ),
  },
  {
    year: 2008,
    label: 'Война в Грузии',
    description: (
      <p>
        В 2008 году отношения Грузии с Россией и Южной Осетией, которая в 1990
        году заявила о выходе из состава Грузии, резко ухудшились. В
        июле-августе в зоне конфликта начались обстрелы. Президент России
        Дмитрий Медведев объявил о начале &quot;операции по принуждению Грузии к
        миру&quot;. Ночью 8 августа 2008 года российские войска продвинулись
        вглубь грузинской территории. Военные действия велись пять дней, по их
        окончании Тбилиси и Москва разорвали дипломатические отношения. После
        войны Москва признала Южную Осетию и Абхазию независимыми государствами.
        Международное сообщество считает эти территории частью Грузии.
      </p>
    ),
  },
  {
    year: 2011,
    label: 'Митинги "за честные выборы"',
    description: (
      <p>
        В декабре 2011 года в Москве прошла серия крупнейших митингов в истории
        современной России. 5 декабря митинг против фальсификации результатов
        выборов в Госдуму прошел на Чистых прудах. По данным организаторов из
        движения &quot;Солидарность&quot;, на акцию вышли около 10 тысяч
        человек. Некоторые участники были арестованы – в том числе политики Илья
        Яшин и Алексей Навальный. 10 декабря на Болотной площади прошел митинг,
        в организации которого принимали участие представители различных
        политических движений (например, &quot;Левый Фронт&quot;,
        &quot;Солидарность&quot;, партия &quot;Яблоко&quot;). По некоторым
        оценкам, он собрал около 100 тысяч человек. Протестующие требовали
        отмены результатов голосования, отставки главы Центральной избирательной
        комиссии Владимира Чурова и расследования нарушений. В конце декабря на
        проспекте Сахарова в Москве прошел еще один митинг &quot;За честные
        выборы&quot;. По оценкам организаторов, в нем участвовали до 120 тысяч
        человек. Его участники приняли резолюцию с требованиями освободить
        политзаключенных, отменить результаты выборов в Государственную думу и
        назначить новые выборы. Власти требования протестующих не выполнили.
      </p>
    ),
  },
  {
    year: 2012,
    label: 'Президентские выборы в России',
    description: (
      <p>
        В мае 2012 года Владимир Путин вновь занял пост президента России после
        четырех лет на посту премьер-министра. Это были первые выборы после
        конституционной реформы, увеличившей президентский срок с четырех до
        шести лет. По официальным данным, Путин получил 63,75% голосов и победил
        в первом туре. Независимые наблюдатели, в том числе ассоциация
        &quot;Голос&quot; и представители ОБСЕ, сообщали о массовых нарушениях.
      </p>
    ),
  },
  {
    year: 2012,
    label: '"Болотное дело"',
    description: (
      <p>
        6 мая 2012 года на Болотной площади в Москве за день до инаугурации
        Владимира Путина прошла протестная акция &quot;Марш миллионов&quot;. Она
        продолжила череду протестов против фальсификаций на выборах. По
        различным оценкам, в митинге приняли участие от 30 до 100 тысяч человек.
        Маршрут шествия был согласован с мэрией, однако в последний момент
        власти его изменили, из-за чего демонстранты не могли попасть к месту
        проведения акции. По мнению организаторов митинга, это стало причиной
        столкновений с полицией и массовых задержаний с применением насилия.
        Всего было задержано около 400 человек, более 30 обвинили в участии в
        &quot;массовых беспорядках&quot; и &quot;насилии над полицейскими&quot;.
        Началось так называемое “Болотное дело”.
      </p>
    ),
  },
  {
    year: 2012,
    label: 'Маша Гессен во главе русской службы Радио Свобода',
    description: (
      <p>
        В сентябре 2012 года главой русской службы РС назначили Машу Гессен,
        ранее – главреда журнала &quot;Вокруг Света&quot;. В бюро
        &quot;Свободы&quot; в Москве было{' '}
        <a
          href="https://www.bbc.com/russian/rolling_news/2012/09/120920_rn_gessen_svoboda_firing"
          target="_blank"
          rel="noreferrer"
        >
          уволено
        </a>
        , около 40 журналистов. В результате протестов в коллективе редакции и
        кампании в прессе в апреле 2013 директором русской службы назначили
        Ирину Лагунину. Часть уволенных сотрудников вернулась к работе в
        Московском бюро.
      </p>
    ),
  },
  {
    year: 2012,
    label: 'Прекращение вещания на средних волнах в РФ',
    description: (
      <p>
        В ноябре 2012 года русская служба Радио Свобода{' '}
        <a
          href="https://www.svoboda.org/a/24718140.html"
          target="_blank"
          rel="noreferrer"
        >
          прекратила
        </a>{' '}
        вещание на средних волнах в России. Стивен Корн, на тот момент
        занимавший пост президента корпорации, заявил, что уход из эфира связан
        с &quot;требованиями новой редакции российского закона о СМИ&quot;. Корн
        ссылался на новую редакцию российского закона &quot;о СМИ&quot;, которая
        запрещала иностранцам или иностранным компаниям владеть более, чем 48%
        медиа, зарегистрированных в России.
      </p>
    ),
  },
  {
    year: 2013,
    label: 'Закон о "гей-пропаганде"',
    description: (
      <p>
        В июне 2013 года Госдума России почти единогласно приняла закон,
        запрещающий &quot;пропаганду нетрадиционных сексуальных отношений среди
        несовершеннолетних&quot;. Под его действие подпадала любая публичная
        информация, связанная с тематикой ЛГБТК+, если она могла стать доступна
        детям. Под &quot;пропагандой&quot; понималось любое обсуждение проблем
        ЛГБТК-людей в России и мире, просветительская деятельность,
        организованные мероприятия, публикации, фильмы, сообщения в социальных
        сетях. Уже в первый год действия закона появились случаи штрафов и
        блокировки публикаций, посвященных проблемам ЛГБТК+.
      </p>
    ),
  },
  {
    year: 2013,
    label: 'Начало Евромайдана в Украине',
    description: (
      <>
        <p>
          21 ноября 2013 года правительство Украины приостановило процесс
          подготовки к подписанию соглашения об ассоциации с Евросоюзом, а
          спустя несколько дней президент Виктор Янукович на саммите ЕС
          отказался подписывать документ. Из-за этого сотни тысяч людей вышли на{' '}
          <a
            href="https://www.currenttime.tv/a/ukraina-ce-evropa-euromaidan-timeline/29610790.html"
            target="_blank"
            rel="noreferrer"
          >
            протесты
          </a>{' '}
          по всей стране, но самая большая акция проходила на площади
          Независимости в Киеве. Украинцы выступали также против коррупции.
          Протесты на Майдане продолжались несколько месяцев, власти их
          неоднократно разгоняли, но революция победила: Янукович и часть
          чиновников бежали из страны.
        </p>

        <p>
          По официальным данным, во время Евромайдана пострадали 2,5 тысячи
          человек, 104 из них погибли. Погибших участников протестов стали
          называть Небесной сотней, а сами события вошли в историю Украины как
          Евромайдан или Революция Достоинства. За ними последовала оккупация{' '}
          <a
            href="https://www.currenttime.tv/a/kak-donetskuyu-oblast-ukrainy-prevratili-v-dnr/32901731.html"
            target="_blank"
            rel="noreferrer"
          >
            регионов Донбасса
          </a>{' '}
          Россией, а также военные действия на востоке страны. Журналисты Радио
          Свобода, в том числе русской службы, активно освещали происходящее.
        </p>
      </>
    ),
  },
  {
    year: 2014,
    label: 'Аннексия Крыма',
    description: (
      <p>
        После массовых протестов в Киеве и бегства президента Украины Виктора
        Януковича из страны российские военные без опознавательных знаков в ночь
        на 27 февраля взяли под контроль здания органов власти Крыма. 16 марта
        под контролем российских военных состоялся референдум &quot;о статусе
        Крыма&quot;. Власти России заявляли, что 96,77% участников поддержало
        &quot;присоединение&quot; к России. Большинство стран мира считают
        действия России аннексией, проведение референдума незаконным и
        противоречащим конституции Украины, а его итоги – недействительными.
      </p>
    ),
  },
  {
    year: 2014,
    label: 'Крушение "Боинга" MH17',
    description: (
      <p>
        Пассажирский &quot;Боинг&quot; компании Malaysian Airlines был сбит в
        небе над Донбассом 17 июля 2014 года. Жертвами катастрофы стали 298
        человек – граждане 17 государств, почти две трети погибших – граждане
        Нидерландов. Суд в Гааге установил, что самолет был сбит ракетой
        &quot;Бук&quot; российского производства. Установку доставили на
        территорию так называемой &quot;ДНР&quot; из Курской области РФ
        незадолго до выстрела. ЕСПЧ и Международная организация гражданской
        авиации также признали России виновной в крушении лайнера. Российская
        сторона причастность к катастрофе отрицает.
      </p>
    ),
  },
  {
    year: 2015,
    label: 'Убийство Бориса Немцова',
    description: (
      <p>
        27 февраля 2015 года Борис Немцов, российский оппозиционный политик,
        бывший губернатор Нижегородской области и бывший первый вице-премьер РФ,
        был застрелен в центре Москвы. Виновными в убийстве признали уроженцев
        Чечни, однако адвокаты и соратники политика заявляли, что заказчики
        убийства не установлены, а расследование было неполным и непрозрачным.
        Журналистские расследования BBC и Bellingcat показали, что за год до
        убийства за Немцовым следил человек, связанный с ФСБ.
      </p>
    ),
  },
  {
    year: 2017,
    label: 'Закон о СМИ-"иноагентах"',
    description: (
      <p>
        В ноябре 2017 года президент России Владимир Путин подписал закон,
        согласно которому средства массовой информации могли признаваться
        &quot;иностранными агентами&quot;, если получали финансирование из-за
        рубежа. Статус &quot;иноагента&quot; обязывает организацию в письменной
        форме ежеквартально отчитываться о своей деятельности, доходах и тратах
        перед Министерством юстиции РФ, детально объяснять, на что были
        потрачены поступившие средства, а также маркировать любые публикации
        специальной пометкой о статусе. Неисполнение требований Минюста влечет
        за собой сначала административную, а после уголовную ответственность.
      </p>
    ),
  },
  {
    year: 2017,
    label: 'Признание Радио Свобода "иностранным агентом"',
    description: (
      <p>
        Под действие закона о СМИ-иноагентах сразу попали несколько проектов
        Радио Свобода, включая русскую службу и региональный сайт Сибирь.Реалии,
        телеканал &quot;Настоящее Время&quot;, сайты татаро-башкирской службы и
        северокавказской службы Радио Свобода, а также сайт украинской службы РС
        Крым.Реалии.
      </p>
    ),
  },
  {
    year: 2018,
    label: 'Первый штраф для СМИ-"иноагента"',
    description: (
      <p>
        В 2018 году суд оштрафовал Радио Свобода за &quot;нарушение статуса
        иностранного агента&quot; на 100 тысяч рублей. Иск &quot;Свободе&quot;
        предъявило Министерство юстиции РФ, поскольку корпорация не предоставила
        &quot;органам государственной власти финансовой информации, вытекающей
        из обязанностей неправительственной организации, выполняющей функции
        &quot;иностранного агента&quot;. Юристы Радио Свобода сообщали в суде,
        что корпорация не могла подать документы в установленный срок, поскольку
        Минюст не разъяснил точный порядок их заполнения.
      </p>
    ),
  },
  {
    year: 2019,
    label: '"Московское дело"',
    description: (
      <p>
        Летом 2019 года избирательные комиссии отказались регистрировать
        независимых кандидатов на выборах в Московскую городскую думу. В столице
        прошли массовые митинги, сопровождавшиеся масштабными задержаниями.
        Более 30 человек стали фигурантами уголовных дел. Преследования
        участников акций впоследствии получили название &quot;Московское
        дело&quot;. Часть обвиняемых получила реальные сроки заключения,
        некоторые покинули Россию.
      </p>
    ),
  },
  {
    year: 2019,
    label: 'Дело Светланы Прокопьевой',
    description: (
      <p>
        Зимой 2019 года Следственный комитет РФ{' '}
        <a
          href="https://www.svoboda.org/a/29754385.html"
          target="_blank"
          rel="noreferrer"
        >
          возбудил
        </a>{' '}
        уголовное дело по статье &quot;об оправдании терроризма&quot; против
        внештатного корреспондента Русской службы Радио Свобода, журналистки
        газеты “Псковская Губерния” Светланы Прокопьевой. Поводом послужил
        комментарий Прокопьевой в эфире радиостанции &quot;Эхо Москвы в
        Пскове&quot; о теракте у здания архангельского ФСБ в 2018 году. Суд
        назначил штраф в полмиллиона рублей. Летом 2019 года Прокопьеву внесли в
        список экстремистов и террористов. Спустя три года ей удалось добиться
        исключения из списка. Прокопьева покинула Россию.
      </p>
    ),
  },
  {
    year: 2020,
    label: 'Штраф за "фейки" о COVID',
    description: (
      <p>
        В 2020 году внештатного корреспондента русской службы Радио Свобода в
        Санкт-Петербурге Татьяну Вольтскую, которая сотрудничала с Радио Свобода
        более 20 лет, суд{' '}
        <a
          href="https://www.svoboda.org/a/31001927.html"
          target="_blank"
          rel="noreferrer"
        >
          оштрафовал
        </a>{' '}
        на 30 тысяч рублей по статье &quot;о распространении ложной информации о
        коронавирусной инфекции&quot;. Поводом для возбуждения административного
        дела стало интервью Вольтской с реаниматологом, в котором врач рассказал
        о нехватке аппаратов ИВЛ и другого оборудования в больницах.
        Административное дело против Вольтской было прекращено в 2021 году из-за
        отсутствия состава преступления.
      </p>
    ),
  },
  {
    year: 2020,
    label: 'Указ о маркировке для СМИ-"иноагентов"',
    description: (
      <p>
        ООсенью 2020 года были приняты дополнения к законодательству &quot;об
        иностранных агентах&quot;, обязавшие маркировать любую информацию,
        попадающую в открытый доступ, специальной формулировкой. В конце того же
        года трое журналистов, сотрудничавшие с русской службой Радио Свобода
        были{' '}
        <a
          href="https://www.svoboda.org/a/31023462.html"
          target="_blank"
          rel="noreferrer"
        >
          признаны
        </a>{' '}
        &quot;иноагентами&quot;.
      </p>
    ),
  },
  {
    year: 2020,
    label: 'Журналисты-"иноагенты"',
    description: (
      <p>
        Многих авторов, которые сотрудничали с русской службой Радио Свобода,
        российский Минюст также вносит в реестр &quot;иноагентов&quot;. В конце
        2020 года в него были{' '}
        <a
          href="https://www.svoboda.org/a/31023462.html"
          target="_blank"
          rel="noreferrer"
        >
          внесены
        </a>{' '}
        трое журналистов, сотрудничавших с русской службой РС. В будущем
        &quot;иноагентами&quot; признают десятки сотрудников РС.
      </p>
    ),
  },
  {
    year: 2021,
    label: 'Акции в поддержку Навального',
    description: (
      <p>
        17 января 2021 года оппозиционного политика Алексея Навального задержали
        в московском аэропорту по прилете из Германии, где он проходил лечение
        после отравления, как полагают, организованного российскими
        спецслужбами. В поддержку Навального по всей стране прошли многотысячные
        митинги, сопровождавшиеся применением силы со стороны полиции. Давление
        на сторонников Навального и преследования несогласных с политикой
        властей продолжились и после подавления массовых уличных протестов.
      </p>
    ),
  },
  {
    year: 2021,
    label: 'Задержание Артема Радыгина',
    description: (
      <p>
        После январских протестов в поддержку Алексея Навального был задержан
        журналист русской службы Радио Свобода Артем Радыгин. Корреспондента{' '}
        <a
          href="https://www.svoboda.org/a/31074358.html"
          target="_blank"
          rel="noreferrer"
        >
          увезли
        </a>{' '}
        на допрос по так называемому &quot;санитарному делу&quot;, в качестве
        обвиняемых по которому проходили организаторы акций в поддержку
        Навального. Вскоре журналиста освободили. ЕСПЧ присудил ему компенсацию
        за жестокое обращение со стороны полиции и препятствие его
        профессиональной деятельности. Задержание Радыгина стало одним из многих
        случаев, когда российские власти препятствовали работе сотрудников Радио
        Свобода и других журналистов.
      </p>
    ),
  },
  {
    year: 2021,
    label: 'Штрафы от Роскомнадзора',
    description: (
      <p>
        Корпорация РСЕ/РС отказалась выполнять указ Роскомнадзора и не стала
        маркировать свои материалы сообщением о статусе &quot;иноагента&quot;,
        считая это вмешательством в свою редакционную политику. Начиная с
        декабря 2020 года Роскомнадзор направил российскому юридическому лицу
        РСЕ/РС уведомления о сотнях штрафов. К концу лета 2021 года их сумма{' '}
        <a
          href="https://www.svoboda.org/a/roskomnadzor-snova-shtrafuet-rse-rs/31418208.html"
          target="_blank"
          rel="noreferrer"
        >
          составляла
        </a>{' '}
        около 250 миллионов рублей. Банковские счета РС в Москве были{' '}
        <a
          href="https://www.svoboda.org/a/31254988.html"
          target="_blank"
          rel="noreferrer"
        >
          заблокированы
        </a>{' '}
        , в офис приходили судебные приставы. В ответ на действия властей
        медиакорпорация подала иск против РФ в Европейский суд по правам
        человека.
      </p>
    ),
  },
  {
    year: 2021,
    label: 'Часть журналистов РС уезжает из России',
    description: (
      <p>
        Весной 2021 года по соображениям{' '}
        <a
          href="https://www.sibreal.org/a/prezident-rse-rs-osudil-presledovanie-zhurnalistov-radio-svoboda/31764870.html"
          target="_blank"
          rel="noreferrer"
        >
          безопасности
        </a>{' '}
        из России уезжает группа журналистов Радио Свобода. Администрация
        медиакорпорации приняла решение о передислокации части редакции в Прагу
        и киевское бюро РСЕ/РС. Московское бюро &quot;Свободы&quot; продолжило
        работу в усеченном составе.
      </p>
    ),
  },
  {
    year: 2021,
    label: 'Новые "иноагенты"',
    description: (
      <p>
        Осенью 2021 года в российский реестр &quot;иноагентов&quot; Минюст{' '}
        <a
          href="https://www.svoboda.org/a/tryoh-zhurnalistok-sotrudnichayuschih-s-radio-svoboda-priznali-inoagentami/31499836.html"
          target="_blank"
          rel="noreferrer"
        >
          внес
        </a>{' '}
        еще троих журналисток, работавших с проектами русской службы. Журналисты
        других служб и проектов Радио Свобода также признаны
        &quot;иноагентами&quot; в РФ.
      </p>
    ),
  },
  {
    year: 2022,
    label: 'Полномасштабное вторжение РФ в Украину',
    description: (
      <p>
        24 февраля 2022 Владимир Путин объявил о начале &quot;Специальной
        военной операции&quot; против Украины. Россия начала полномасштабное
        вторжение на территорию соседней страны. Большинство западных государств
        и их союзников признали вторжение актом агрессии. Более 60 государств
        ввели персональные и секторальные санкции против России, Владимира
        Путина и других высокопоставленных чиновников.
      </p>
    ),
  },
  {
    year: 2022,
    label: 'Блокировка сайтов РС в России',
    description: (
      <p>
        В начале 2022 года Роскомнадзор{' '}
        <a
          href="https://www.svoboda.org/a/sayt-radio-svoboda-zablokirovan-v-rossii/31732804.html"
          target="_blank"
          rel="noreferrer"
        >
          заблокировал
        </a>{' '}
        сайты русской службы Радио Свобода. Причиной блокировки власти РФ
        назвали &quot;распространение фейков о происходящем на территории
        Украины&quot;.
      </p>
    ),
  },
  {
    year: 2022,
    label: 'Закрытие московского бюро РС ',
    description: (
      <>
        <p>
          В марте 2022 года руководство РСЕ/РС приняло решение о закрытии бюро в
          Москве из-за репрессий со стороны российских властей и опасений за
          безопасность журналистов.
        </p>
        <p>
          За несколько дней до этого Владимир Путин подписал так называемый
          закон &quot;о фейках&quot;. Он предусматривает до 15 лет лишения
          свободы за высказывания, которые ставят под сомнение официальную
          трактовку военного вторжения на территорию Украины.
        </p>
      </>
    ),
  },
  {
    year: 2023,
    label: 'Банкротство в России',
    description: (
      <p>
        В 2023 году Арбитражный суд в Москве{' '}
        <a
          href="https://www.svoboda.org/a/arbitrazhnyy-sud-v-moskve-priznal-bankrotom-ooo-rse-rc-/32315064.html"
          target="_blank"
          rel="noreferrer"
        >
          признал
        </a>{' '}
        банкротом юридическое лицо Радио Свобода в России из-за накопившихся
        штрафов, сумма которых превышала миллиард рублей. Против
        представительства РСЕ/РС в России и его бывшего генерального директора в
        российских судах рассматривалось более 1000 административных дел.
      </p>
    ),
  },
  {
    year: 2024,
    label: 'Смерть Алексея Навального',
    description: (
      <>
        <p>
          16 февраля 2024 года российский оппозиционный политик Алексей
          Навальный погиб в колонии строго режима &quot;Полярный волк&quot; на
          Ямале. За несколько дней до гибели Навальный в 27-й раз был помещен в
          ШИЗО – камеру с самыми жесткими условиями содержания. Российские
          власти объявили, что политик умер &quot;естественной смертью&quot;.
          Сторонники Навального, независимые журналисты, политические и
          общественные деятели придерживаются{' '}
          <a
            href="https://theins.ru/inv/274921"
            target="_blank"
            rel="noreferrer"
          >
            версии
          </a>{' '}
          об убийстве.
        </p>
        <p>
          Более 40 государств потребовали независимого международного
          расследования обстоятельств смерти Навального. Главы стран ЕС и США
          заявляли, что российские власти несут ответственность за гибель
          оппозиционера.
        </p>
      </>
    ),
  },
  {
    year: 2024,
    label: 'РСЕ/РС – "нежелательная организация"',
    description: (
      <p>
        В феврале 2024 года российское министерство юстиции{' '}
        <a
          href="https://www.svoboda.org/a/im-uzhe-vse-ravno-radio-svoboda-stalo-nezhelateljnoy-organizatsiey-/32828021.html"
          target="_blank"
          rel="noreferrer"
        >
          признало
        </a>{' '}
        корпорацию Радио Свободная Европа / Радио Свобода &quot;нежелательной
        организацией&quot;. С тех пор любое сотрудничество с радио в России
        является нарушением административного и уголовного кодекса.
      </p>
    ),
  },
  {
    year: 2024,
    label: 'Президентские выборы в России',
    description: (
      <p>
        Владимир Путин в пятый раз занял пост президента России. Вновь
        участвовать в выборах он смог благодаря внесенным в Конституцию
        поправкам, одобренным в 2020 году. В прежней редакции основного закона
        одно и то же лицо не могло занимать пост главы государства более двух
        сроков подряд. Президентские выборы прошли практически без присутствия
        международных миссий ОБСЕ и при существенных ограничениях для
        независимых российских наблюдателей. По официальным данным Центральной
        избирательной комиссии, Путин получил 87,28% голосов избирателей при
        явке 77,44%. По данным аналитиков, независимых наблюдателей и СМИ в ходе
        кампании фиксировались массовые нарушения.
      </p>
    ),
  },
  {
    year: 2024,
    label: 'РСЕ/РС выиграла суд против России в ЕСПЧ',
    description: (
      <p>
        В октябре 2024 года Европейский суд по правам человека{' '}
        <a
          href="https://www.svoboda.org/a/33154972.html"
          target="_blank"
          rel="noreferrer"
        >
          вынес решение
        </a>{' '}
        по иску, тремя годами ранее поданному РСЕ/РС. Суд постановил, что
        российские власти нарушили статьи 10 и 11 Европейской конвенции о правах
        человека и присудил истцам компенсацию в размере около 950 тысяч евро.
      </p>
    ),
  },
  {
    year: 2025,
    label: 'Дональд Трамп во второй раз избран президентом США',
    description: (
      <p>
        Дональд Трамп был избран 47-м президентом Соединенных Штатов Америки. Он
        стал вторым политиком в истории США, избранным на второй
        непоследовательный срок.
      </p>
    ),
  },
  {
    year: 2025,
    label: 'USAGM отказывает в выдаче грантов РС',
    description: (
      <p>
        15 марта 2025 года Агентство США по глобальным медиа (USAGM), попечитель
        РСЕ/РС, приняло решение отказать медиакорпорации в выдаче гранта,
        который ранее уже утвердил Конгресс США. Это привело к существенным
        ограничениям в деятельности корпорации. Средства на 2025 год РСЕ/РС
        удалось получить через суд. Несмотря на финансовые трудности Радио
        Свобода продолжает свою работу.
      </p>
    ),
  },
  {
    year: 2025,
    label: 'Новые "иноагенты"',
    description: (
      <p>
        По состоянию на декабрь 2025 года восемь сотрудников русской службы РС
        внесены Министерством юстиции РФ в реестр &quot;иностранных
        агентов&quot; в личном качестве. Еще более трех десятков журналистов,
        сотрудничавших с русской службой, также признаны
        &quot;иноагентами&quot;.
      </p>
    ),
  },
]
